import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["tabs"];
import { Tabs as Base } from "@cancer-council-queensland/react";
import { renderStoryblokComponents } from "..";
import RichText from "./richText";
import { jsx as _jsx } from "react/jsx-runtime";
export var Tabs = _ref => {
  var {
    tabs
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_jsx(Base, _extends({}, rest, {
    tabs: tabs.map(tab => {
      return _extends({}, tab, {
        description: RichText(tab.description),
        content: renderStoryblokComponents(tab.content)
      });
    })
  }));
};
//# sourceMappingURL=tabs.js.map